import { createOpenAICompatible } from "@ai-sdk/openai-compatible";
import { envVariables } from "@/lib/envVariables";

/**
 * Baseten provider configuration using OpenAI-compatible API
 */
export const baseten = createOpenAICompatible({
  name: "baseten",
  baseURL: "https://inference.baseten.co/v1",
  headers: {
    Authorization: `Bearer ${envVariables.BASETEN_API_KEY}`,
  },
});

/**
 * Model ID constants for Baseten models
 */
export const GPT_OSS_120B = "openai/gpt-oss-120b";
export const QWEN3_235B = "Qwen/Qwen3-235B-A22B-Instruct-2507";

/**
 * Helper function to get Baseten provider with GPT_OSS_120B model
 */
export const gptOss120B = () => baseten(GPT_OSS_120B);

/**
 * Helper function to get Baseten provider with QWEN3_235B model
 */
export const qwen3_235B = () => baseten(QWEN3_235B);
